import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import language from "../../language";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchMeasureData = async (lng = "english", params) => {
  const { page, limit, name, type, id, code } = params || {};

  const { token } = await getStorage();
  try {
    const options = {
      method: "GET",
      url: `${API_URL}/vitalSignMeasure`,
      params: {
        page: page,
        limit: limit,
        name,
        code,
        id,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const queryRes = await api(options);

    let { data, count, totalRecords } = queryRes.data;

    if (type === "dropdown") {
      return (queryRes?.data?.data || queryRes?.data).map((el) => {
        return {
          ...el,
          label: el.code + " - " + el.name,
          value: el._id,
        };
      });
    }

    return !page && !limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deleteMeasure = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const options = {
      method: "DELETE",
      url: `${API_URL}/vitalSignMeasure`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_data);
  } catch (error) {
    toastMessage("error", error);
  }
};
